import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CommonButtonV1 } from 'gemlux-common-components';
import CustomModal from '../../V1/CustomModal/CustomModal';
import { theme } from '../../../theme/theme';
import DeleteSvg from '../../../assets/img/delete-icon-new.svg';
import WarningSvg from '../../../assets/img/warning-round-icon.svg';

export type RecallInvitationProps = {
  open: boolean;
  onClose: () => void;
  onRecall: () => void;
  email: string;
  isRecalling?: boolean;
};

const RecallInvitation: React.FC<RecallInvitationProps> = ({ open, onClose, onRecall, email, isRecalling }) => (
  <CustomModal
    modal
    open={open}
    handleClose={onClose}
    Icon={<Box component="img" src={isRecalling ? DeleteSvg : WarningSvg} alt="Delete Icon" />}
    title={isRecalling ? 'Following invite will be recalled!' : 'Confirm Invite!'}
    subTitle={
      isRecalling
        ? 'Are you sure you want to recall the invite for this subordinate?'
        : 'Do you confirm, you want to re-invite following email address?'
    }
  >
    <Box display="flex" flexDirection="column" gap="8px" justifyContent="end" alignItems="center" mt={1}>
      <Typography variant="textH6" color={theme.palette.common.black} textAlign="center">
        {email}
      </Typography>
      <CommonButtonV1
        variant="contained"
        data-testid="recall-button"
        sx={{
          width: '100%',
          backgroundColor: isRecalling ? theme.palette.shades.errorBrightMain : theme.palette.shades.primaryBrightDark,
          border: `1px solid ${theme.palette.shades.grayBorder}`,
          marginTop: '10px',
        }}
        onClick={onRecall}
      >
        {isRecalling ? ' Yes, recall' : 'Yes, send invites'}
      </CommonButtonV1>
      <CommonButtonV1
        variant="outlined"
        data-testid="cancel-button"
        backgroundColor="transparent"
        sx={{
          width: '100%',
          color: '#5261FE',
          border: `1px solid ${theme.palette.shades.buttonOutline}`,
        }}
        onClick={onClose}
      >
        Cancel
      </CommonButtonV1>
    </Box>
  </CustomModal>
);

export default RecallInvitation;
